import type { ScheduleType } from '@repo/api-codegen';

export const scheduleTypeOptions: {
	label: string;
	value: ScheduleType;
}[] = [
	{
		label: 'Hourly',
		value: 'hourly',
	},
	{
		label: 'Daily',
		value: 'daily',
	},
	{
		label: 'Weekly',
		value: 'weekly',
	},
	{
		label: 'Custom (cron)',
		value: 'cron',
	},
];

export const DAYS_OF_WEEK = [
	{
		label: 'Sunday',
		value: '0',
	},
	{
		label: 'Monday',
		value: '1',
	},
	{
		label: 'Tuesday',
		value: '2',
	},
	{
		label: 'Wednesday',
		value: '3',
	},
	{
		label: 'Thursday',
		value: '4',
	},
	{
		label: 'Friday',
		value: '5',
	},
	{
		label: 'Saturday',
		value: '6',
	},
];

export const HOURS_OF_DAY = Array.from({ length: 24 }, (_, i) => {
	const hour = i % 12 || 12; // Convert 0 to 12 for 12 AM
	const period = i < 12 ? 'AM' : 'PM';
	return {
		label: `${hour}:00 ${period} UTC`,
		value: String(i),
	};
});
